export const theme = {
    colors: {
        primary: "#800020",
        white: "#FFFFFF",
        black: "#000000",
        lightGray: "#F5F5F5", // Fundo geral
        gray: "#E0E0E0", // Cor para "Em Andamento"
        yellow: "#FFD700", // Cor para "Atrasado"
        green: "#2E8B57", // Cor para "Concluído"
        blue: "#163560", // Azul para etapas ativas
        textLight: "#495057",
    },
    spacing: {
        small: "8px",
        medium: "16px",
        large: "24px",
    },
    borderRadius: "8px",
};
